/* =========================================================================
   capini-model-gate.js — a opção de MODELO nasce SEM nada escolhido
   -------------------------------------------------------------------------
   POR QUE EXISTE (medido em 04/09/2026)
   O cliente não seleciona o modelo errado — ele não seleciona NADA, e o tema
   entrega a primeira variante já marcada (quase sempre o iPhone 17 padrão).
   Varredura de 306 pedidos desde 01/07: 37 line items com iPhone 17 padrão,
   2 viraram reclamação (#1805 Mike King · #1753 Nanna). Cada caso custa a peça
   paga duas vezes ao fornecedor + frete + a errada perdida.

   O QUE FAZ
   Na página do produto, apaga a APARÊNCIA de "já escolhido" na opção de MODELO
   e trava o botão de compra até o cliente escolher de fato. A COR fica como
   está (martelo do Talles 04/09 — e o dado apoia: zero casos de cor errada no
   error-log do CS; a cor tem feedback visual, o modelo não tem nenhum).

   DUAS DECISOES DE PROJETO, E O PORQUE
   1) NAO mexe no valor que vai pro formulario. Zerar o input[name=optionN]
      faria o form enviar variante vazia se este script falhasse — um erro no
      carrinho, pior que o problema original. Mexemos so no visivel + na trava.
      Consequencia: preco e foto continuam intactos ao abrir a pagina.
   2) NAO le o nome da opcao pelo texto da tela. O storefront e traduzido pelo
      navegador do cliente ("Color:" vira "Cor:"), o que quebraria a deteccao.
      O nome canonico vem de /products/<handle>.js, sempre em ingles.

   NAO toca em snippets/foxify-*.liquid — regerados pelo app a qualquer momento.

   FALHA SEGURA: qualquer erro aqui devolve a loja ao comportamento antigo
   (variante pre-selecionada, botao liberado). Nunca deixa a pagina sem botao.
   ========================================================================= */
(function () {
  'use strict';

  var MARCA = 'capini-model-gate';

  /* --- 1. Que opcao e "modelo"? ------------------------------------------
     Nomes canonicos medidos no catalogo (79 produtos, /products.json 06/09):
       modelo -> Select your iPhone (23) · Model (6) · Compatibility by Model (7)
                 Select your Apple Watch (7) · Select your MacBook (3)
                 Compatible-Phone Models (2) · Select your laptop (1)
                 Material|Compatibility by Model (1)
       nao    -> Color/Colour · Size · Material · Capacity · Buckle · Bundle
                 Colour and Buckle · Leather and Hardware · Default Title     */

  var NUNCA = ['color', 'colour', 'size', 'material', 'capacity', 'buckle',
               'bundle', 'colour and buckle', 'color and buckle',
               'leather and hardware', 'default title'];

  function normaliza(s) {
    return String(s || '')
      .replace(/:\s*$/, '')
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      .trim().toLowerCase();
  }

  function ehModelo(nome) {
    var n = normaliza(nome);
    if (!n) return false;
    if (NUNCA.indexOf(n) !== -1) return false;          // igualdade exata, nunca "contem"
    return /\bmodel/.test(n) || /^select your\b/.test(n) || /compatib/.test(n);
  }

  /* --- 2. Estado -------------------------------------------------------- */

  var campos = [];
  var ligado = false;

  /* --- 3. Apagar a aparencia de "ja escolhido" --------------------------
     Tres formatos convivem no tema:
       a) dropdown custom -> <button class="select"><span id="...-selected-value">
       b) radios          -> input[type=radio][name=optionN]
       c) select nativo   -> select[name=optionN]                            */

  function rotuloPlaceholder(nome) {
    var n = normaliza(nome);
    if (/^select your\b/.test(n)) return String(nome).replace(/:\s*$/, '');
    return 'Select your model';
  }

  function apagarAparencia(fs, nome) {
    var texto = rotuloPlaceholder(nome);
    var mexeu = false;

    var vov = fs.querySelector('variant-option-value');
    if (vov && vov.textContent.trim()) {
      if (!vov.hasAttribute('data-capini-original')) {
        vov.setAttribute('data-capini-original', vov.textContent.trim());
      }
      vov.textContent = '';
      mexeu = true;
    }

    var span = fs.querySelector('button.select span[id$="-selected-value"]')
            || fs.querySelector('button.select span');
    if (span) {
      if (!span.hasAttribute('data-capini-original')) {
        span.setAttribute('data-capini-original', span.textContent.trim());
      }
      span.textContent = texto;
      span.style.opacity = '.6';
      mexeu = true;
    }

    var opcoes = fs.querySelectorAll('[role="option"][aria-selected="true"]');
    for (var i = 0; i < opcoes.length; i++) {
      opcoes[i].setAttribute('aria-selected', 'false');
      mexeu = true;
    }

    var radios = fs.querySelectorAll('input[type="radio"]');
    if (radios.length > 1) {
      for (var j = 0; j < radios.length; j++) {
        if (radios[j].checked) { radios[j].checked = false; mexeu = true; }
      }
    }

    var sel = fs.querySelector('select');
    if (sel && sel.options.length > 1 && !sel.querySelector('option[data-capini-placeholder]')) {
      var ph = document.createElement('option');
      ph.value = ''; ph.textContent = '- ' + texto + ' -';
      ph.setAttribute('data-capini-placeholder', '1');
      sel.insertBefore(ph, sel.firstChild);
      ph.selected = true;
      mexeu = true;
    }

    return mexeu;
  }

  /* --- 4. Trava e aviso -------------------------------------------------- */

  function botoesDeCompra() {
    var lista = [];
    var seletores = ['buy-buttons button[type="submit"]',
                     'form[action*="/cart/add"] button[type="submit"]',
                     '.shopify-payment-button button',
                     '[data-capini-kit-atc]'];
    for (var s = 0; s < seletores.length; s++) {
      var achados = document.querySelectorAll(seletores[s]);
      for (var i = 0; i < achados.length; i++) {
        if (lista.indexOf(achados[i]) === -1) lista.push(achados[i]);
      }
    }
    return lista;
  }

  function aviso(fs, texto) {
    var alvo = fs.querySelector('.variant-picker__option-info') || fs;
    var el = fs.querySelector('[data-capini-gate-aviso]');
    if (!texto) { if (el) el.remove(); return; }
    if (!el) {
      el = document.createElement('p');
      el.setAttribute('data-capini-gate-aviso', '1');
      el.style.cssText = 'margin:.4rem 0 0;font-size:.8125rem;line-height:1.35;opacity:.75';
      alvo.appendChild(el);
    }
    el.textContent = texto;
  }

  function aplicar() {
    var faltam = 0;
    for (var i = 0; i < campos.length; i++) {
      var c = campos[i];
      if (c.escolheu) { aviso(c.fieldset, ''); continue; }
      faltam++;
      aviso(c.fieldset, 'Choose yours to continue.');
    }

    var botoes = botoesDeCompra();
    for (var k = 0; k < botoes.length; k++) {
      var b = botoes[k];
      if (faltam) {
        if (!b.hasAttribute('data-capini-gate-travado')) {
          b.setAttribute('data-capini-gate-travado', '1');
          b.setAttribute('aria-disabled', 'true');
          b.disabled = true;
          b.style.opacity = '.45';
          b.style.cursor = 'not-allowed';
        }
      } else if (b.hasAttribute('data-capini-gate-travado')) {
        b.removeAttribute('data-capini-gate-travado');
        b.removeAttribute('aria-disabled');
        b.disabled = false;
        b.style.opacity = '';
        b.style.cursor = '';
      }
    }
  }

  /* --- 5. Ouvir a escolha do cliente ------------------------------------ */

  function marcarEscolhido(fs) {
    for (var i = 0; i < campos.length; i++) {
      if (campos[i].fieldset === fs && !campos[i].escolheu) {
        campos[i].escolheu = true;
        var span = fs.querySelector('button.select span[id$="-selected-value"]');
        if (span) span.style.opacity = '';
        aplicar();
        return;
      }
    }
  }

  function ouvir() {
    document.addEventListener('click', function (ev) {
      if (!ev.target || !ev.target.closest) return;
      var fs = ev.target.closest('fieldset');
      if (!fs) return;
      // so conta como escolha o clique numa OPCAO — nao em abrir o dropdown
      var opt = ev.target.closest('[role="option"], label[for], .popover-listbox__option');
      if (opt) setTimeout(function () { marcarEscolhido(fs); }, 40);
    }, true);

    document.addEventListener('change', function (ev) {
      if (!ev.target || !ev.target.closest) return;
      var fs = ev.target.closest('fieldset');
      if (fs) marcarEscolhido(fs);
    }, true);
  }

  /* --- 6. Ligar --------------------------------------------------------- */

  function iniciar() {
    if (ligado) return;

    // Quem chegou por link com a variante ja escolhida (anuncio, catalogo Meta,
    // e-mail, "comprar de novo") NAO passa pelo gate: ele ja decidiu.
    if (/[?&]variant=\d+/.test(window.location.search)) return;

    var picker = document.querySelector('variant-picker[handle]');
    if (!picker) return;
    if (!document.querySelector('form[action*="/cart/add"]')) return;

    var handle = picker.getAttribute('handle');
    if (!handle) return;

    fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (prod) {
        if (!prod || !prod.options || !prod.options.length) return;

        var fieldsets = picker.querySelectorAll('fieldset');
        for (var i = 0; i < prod.options.length; i++) {
          var nome = typeof prod.options[i] === 'string' ? prod.options[i] : prod.options[i].name;
          if (!ehModelo(nome)) continue;

          // casa o fieldset por variant-option-value[for="optionN"] — imune a traducao
          var ancora = picker.querySelector('variant-option-value[for="option' + (i + 1) + '"]');
          var fs = ancora ? ancora.closest('fieldset') : fieldsets[i];
          if (!fs) continue;

          // opcao com um valor so: nao ha o que escolher
          var valores = {};
          if (prod.variants) {
            for (var v = 0; v < prod.variants.length; v++) {
              valores[prod.variants[v]['option' + (i + 1)]] = 1;
            }
          }
          if (Object.keys(valores).length < 2) continue;

          if (apagarAparencia(fs, nome)) {
            campos.push({ fieldset: fs, indice: i + 1, nome: nome, escolheu: false });
          }
        }

        if (!campos.length) return;
        ligado = true;
        ouvir();
        aplicar();

        // Cinto de seguranca: se o tema re-renderizar o botao, a trava volta.
        if (window.MutationObserver) {
          new MutationObserver(function () { aplicar(); })
            .observe(document.querySelector('.product-info') || document.body,
                     { childList: true, subtree: true });
        }

        document.documentElement.setAttribute('data-' + MARCA, 'on');
      })
      .catch(function (e) {
        if (window.console && console.warn) console.warn('[' + MARCA + '] desligado:', e);
      });
  }

  function seguro() {
    try { iniciar(); } catch (e) {
      // Silencioso de proposito: a loja volta ao comportamento antigo e continua
      // vendendo. Um gate quebrado nunca pode tirar o botao da tela.
      if (window.console && console.warn) console.warn('[' + MARCA + '] desligado:', e);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', seguro);
  } else {
    seguro();
  }
  window.addEventListener('load', function () { setTimeout(seguro, 300); });
})();
